import React, { useState, useEffect } from 'react'
import axios from 'axios'
import videoImg from "../../Images/project.png"
import renaissance from "../../Images/renaissance.png"
import total from "../../Images/total.png"
import seepco from "../../Images/sepco.png"
import nnpc from "../../Images/antan.png"
import antan from "../../Images/antan.png"
import chevron from "../../Images/cheron.png"
import heirs from "../../Images/heirs.png"
import { CiEdit } from 'react-icons/ci'

const BASE_URL = "https://staging.pteshstudios.com";

const resolveSrc = (value, fallback = null) => {
  if (!value) return fallback;
  if (value instanceof File) return URL.createObjectURL(value);
  if (typeof value === "string") return value.startsWith("http") ? value : `${BASE_URL}/${value}`;
  return fallback;
};

const STATUS_OPTIONS = ["Ongoing", "Completed"];

const staticProjects = [
  { partnerLogo: renaissance, title: "EGBEMA WEST WELL 13 ACCESS ROAD PROJECT", status: "Ongoing" },
  { partnerLogo: renaissance, title: "ASSA NORTH COMMUNITY ELECTRIFICATION INTERDEPENDENCY PROJECT (ANOH CEIP)", status: "Ongoing" },
  { partnerLogo: total, title: "OML 58 SOLARIZATION PROJECT AT OBITE, RIVERS STATE.", status: "Completed" },
  { partnerLogo: seepco, title: "CONSTRUCTION OF RESIDENTIAL COLONY AT AGU COMMUNITY IN OHAJI/EGBEMA LGA, IMO STATE", status: "Ongoing" },
  { partnerLogo: seepco, title: "CONSTRUCTION OF A RESIDENTIAL COLONY IN KWALE, DELTA STATE", status: "Completed" },
  { partnerLogo: renaissance, title: "PROVISION OF SUPPORT SERVICES FOR GOVERNMENT SECURITY AGENCIES (GSA)", status: "Ongoing" },
  { partnerLogo: total, title: "PROVISION OF SUPPORT & ADMINISTRATIVE SUPPORT SERVICES", status: "Ongoing" },
  { partnerLogo: nnpc, title: "MANPOWER SUPPLY SERVICES", status: "Completed" },
  { partnerLogo: antan, title: "MANPOWER SUPPLY SERVICES", status: "Completed" },
  { partnerLogo: total, title: "OML 58 OBAGI UPGRADE", status: "Completed" },
  { partnerLogo: total, title: "OFON 102 FIELD DEVELOPMENT", status: "Completed" },
  { partnerLogo: chevron, title: "TURNAROUND MAINTENANCE PROJECTS FOR CHEVRON, WHICH INCLUDES WORK ON THE ESCRAVOS GAS PLANT, THE FSO (FLOATING STORAGE AND OFFLOADING) FACILITY, AND THE GAS-TO-LIQUIDS FACILITY AGBAMI FPSO MAINTENANCE", status: "Completed" },
  { partnerLogo: heirs, title: "INSTALLATION OF PAVING STONE", status: "Completed" },
];

// ─── Edit Modal ───────────────────────────────────────────────────────────────
const EditModal = ({ isOpen, onClose, pageData, onRefresh }) => {
  const [heroTitle, setHeroTitle] = useState("");
  const [heroImage, setHeroImage] = useState(null);
  const [heroLoading, setHeroLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [editStates, setEditStates] = useState({});
  const [editLoadings, setEditLoadings] = useState({});
  const [reorderLoading, setReorderLoading] = useState(false);
  const [newProject, setNewProject] = useState({ name: "", description: "", status: "Ongoing", photo: null });
  const [addLoading, setAddLoading] = useState(false);

  // FIX: useEffect is BEFORE the early return so it always runs when
  // isOpen/pageData change — if it were after `if (!isOpen) return null`,
  // the component would unmount on close and the effect would never re-fire.
  useEffect(() => {
    if (pageData && isOpen) {
      setHeroTitle(pageData.title || "");
      setHeroImage(null); // reset file picker on each open

      const sorted = [...(pageData.projects || [])].sort((a, b) => a.order - b.order);
      setProjects(sorted);

      const states = {};
      sorted.forEach((p) => {
        states[p._id] = {
          name:        p.name        || "",
          description: p.description || "",
          status:      p.status      || "Ongoing",
          photo:       p.photo       || null,
        };
      });
      setEditStates(states);
    }
  }, [pageData, isOpen]); // both deps so modal re-syncs every time it opens

  if (!isOpen) return null;

  // ── Save hero title + image (PUT) ──
  const handleSaveHero = async () => {
    setHeroLoading(true);
    try {
      const form = new FormData();
      form.append("title", heroTitle);
      // Key must match what multer expects on the backend — check your
      // upload.single("heroImage") or upload.single("image") in the route
      if (heroImage instanceof File) form.append("heroImage", heroImage);

      console.log("Saving hero — title:", heroTitle, "| new image:", heroImage?.name ?? "none");

      await axios.put(`${BASE_URL}/api/project`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onRefresh();
    } catch (err) {
      console.error("Failed to update hero:", err);
    } finally {
      setHeroLoading(false);
    }
  };

  // ── Edit project field ──
  const handleEditField = (id, field, value) => {
    setEditStates((prev) => ({ ...prev, [id]: { ...prev[id], [field]: value } }));
  };

  const handleEditFile = (id, file) => {
    setEditStates((prev) => ({ ...prev, [id]: { ...prev[id], photo: file } }));
  };

  // ── Save project (PATCH) ──
  const handleSaveProject = async (id, order) => {
    setEditLoadings((prev) => ({ ...prev, [id]: true }));
    try {
      const p = editStates[id];

      console.log("Saving project:", id, "| new photo:", p.photo instanceof File ? p.photo.name : "none (keeping existing)");

      const form = new FormData();
      form.append("name",        p.name);
      form.append("description", p.description ?? "");
      form.append("status",      p.status);
      form.append("order",       order);
      // Only append the photo if the user actually picked a new file —
      // if it's still a string (existing URL) we leave it out so the
      // backend keeps the current image instead of wiping it
      if (p.photo instanceof File) form.append("photo", p.photo);

      await axios.patch(`${BASE_URL}/api/project/project/${id}`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onRefresh();
    } catch (err) {
      console.error("Failed to update project:", err);
    } finally {
      setEditLoadings((prev) => ({ ...prev, [id]: false }));
    }
  };

  // ── Delete project (DELETE) ──
  const handleDeleteProject = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/api/project/project/${id}`);
      setProjects((prev) => prev.filter((p) => p._id !== id));
      onRefresh();
    } catch (err) {
      console.error("Failed to delete project:", err);
    }
  };

  // ── Reorder (PATCH /api/project/reorder) ──
  const handleMove = async (index, direction) => {
    const swapIndex = direction === "up" ? index - 1 : index + 1;
    if (swapIndex < 0 || swapIndex >= projects.length) return;
    const newList = [...projects];
    [newList[index], newList[swapIndex]] = [newList[swapIndex], newList[index]];
    setProjects(newList);
    setReorderLoading(true);
    try {
      await axios.patch(`${BASE_URL}/api/project/reorder`, {
        projects: newList.map((p, i) => ({ id: p._id, order: i })),
      });
      onRefresh();
    } catch (err) {
      console.error("Failed to reorder projects:", err);
    } finally {
      setReorderLoading(false);
    }
  };

  // ── Add new project (POST) ──
  const handleAddProject = async () => {
    setAddLoading(true);
    try {
      console.log("Adding project — photo:", newProject.photo instanceof File ? newProject.photo.name : "none");

      const form = new FormData();
      form.append("name",        newProject.name);
      form.append("description", newProject.description);
      form.append("status",      newProject.status);
      form.append("order",       projects.length);
      if (newProject.photo instanceof File) form.append("photo", newProject.photo);

      await axios.post(`${BASE_URL}/api/project/project`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setNewProject({ name: "", description: "", status: "Ongoing", photo: null });
      onRefresh();
    } catch (err) {
      console.error("Failed to add project:", err);
    } finally {
      setAddLoading(false);
    }
  };

  return (
    <div className="em-overlay" onClick={onClose}>
      <div className="em-modal" onClick={(e) => e.stopPropagation()}>

        <div className="em-header">
          <h2 className="em-title">Edit Projects Page</h2>
          <button className="em-close" onClick={onClose} aria-label="Close">&times;</button>
        </div>

        <div className="em-body">

          {/* ── HERO SECTION ── */}
          <div className="em-section">
            <h3 className="em-section-title">Hero</h3>
            <div className="em-field">
              <label className="em-label">Page Title</label>
              <input
                className="em-input"
                type="text"
                placeholder="e.g. Our Work Does the Talking."
                value={heroTitle ?? ""}
                onChange={(e) => setHeroTitle(e.target.value)}
              />
            </div>
            <div className="em-field">
              <label className="em-label">Hero Image</label>
              <input
                className="em-file-input"
                type="file"
                accept="image/*"
                onChange={(e) => setHeroImage(e.target.files[0])}
              />
              {/* Show new file preview if picked, otherwise show current saved image */}
              {heroImage instanceof File ? (
                <img src={URL.createObjectURL(heroImage)} alt="Hero preview" className="em-file-preview" />
              ) : pageData?.heroImage ? (
                <img src={resolveSrc(pageData.heroImage)} alt="Current hero" className="em-file-preview" />
              ) : null}
            </div>
            <button className="em-btn-save" onClick={handleSaveHero} disabled={heroLoading}>
              {heroLoading ? "Saving..." : "Save Hero"}
            </button>
          </div>

          <div className="em-divider" />

          {/* ── EXISTING PROJECTS ── */}
          <div className="em-section">
            <h3 className="em-section-title">
              Projects {reorderLoading && <span className="em-hint">(Reordering...)</span>}
            </h3>

            {projects.map((project, index) => {
              const state = editStates[project._id] || {};
              const isLoading = editLoadings[project._id] || false;
              return (
                <div className="em-expertise-card" key={project._id}>
                  <div className="em-expertise-card-header">
                    <span className="em-expertise-num">Project {String(index + 1).padStart(2, "0")}</span>
                    <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                      <button className="em-remove-btn" onClick={() => handleMove(index, "up")} disabled={index === 0 || reorderLoading} title="Move up">↑</button>
                      <button className="em-remove-btn" onClick={() => handleMove(index, "down")} disabled={index === projects.length - 1 || reorderLoading} title="Move down">↓</button>
                      <button className="em-remove-btn" onClick={() => handleDeleteProject(project._id)} aria-label="Delete">&times;</button>
                    </div>
                  </div>

                  <div className="em-field">
                    <label className="em-label">Partner Logo</label>
                    <input className="em-file-input" type="file" accept="image/*"
                      onChange={(e) => handleEditFile(project._id, e.target.files[0])} />
                    {/* Show new file if picked, otherwise show current saved photo */}
                    {state.photo instanceof File ? (
                      <img src={URL.createObjectURL(state.photo)} alt="New logo preview" className="em-file-preview" />
                    ) : state.photo ? (
                      <img src={resolveSrc(state.photo)} alt="Current logo" className="em-file-preview" />
                    ) : null}
                  </div>

                  <div className="em-field">
                    <label className="em-label">Project Title</label>
                    <input className="em-input" type="text" placeholder="e.g. OML 58 OBAGI UPGRADE"
                      value={state.name ?? ""}
                      onChange={(e) => handleEditField(project._id, "name", e.target.value)} />
                  </div>

                  <div className="em-field">
                    <label className="em-label">Description <span className="em-hint">(optional)</span></label>
                    <textarea className="em-textarea" placeholder="Enter project description"
                      value={state.description ?? ""}
                      onChange={(e) => handleEditField(project._id, "description", e.target.value)} />
                  </div>

                  <div className="em-field">
                    <label className="em-label">Status</label>
                    <select className="em-input" value={state.status ?? "Ongoing"}
                      onChange={(e) => handleEditField(project._id, "status", e.target.value)}>
                      {STATUS_OPTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </div>

                  <button className="em-btn-save" onClick={() => handleSaveProject(project._id, index)} disabled={isLoading}>
                    {isLoading ? "Saving..." : "Save Project"}
                  </button>
                </div>
              );
            })}
          </div>

          <div className="em-divider" />

          {/* ── ADD NEW PROJECT ── */}
          <div className="em-section">
            <h3 className="em-section-title">Add New Project</h3>

            <div className="em-field">
              <label className="em-label">Partner Logo</label>
              <input className="em-file-input" type="file" accept="image/*"
                onChange={(e) => setNewProject((p) => ({ ...p, photo: e.target.files[0] }))} />
              {newProject.photo instanceof File && (
                <img src={URL.createObjectURL(newProject.photo)} alt="New project preview" className="em-file-preview" />
              )}
            </div>

            <div className="em-field">
              <label className="em-label">Project Title</label>
              <input className="em-input" type="text" placeholder="e.g. OML 58 OBAGI UPGRADE"
                value={newProject.name ?? ""}
                onChange={(e) => setNewProject((p) => ({ ...p, name: e.target.value }))} />
            </div>

            <div className="em-field">
              <label className="em-label">Description <span className="em-hint">(optional)</span></label>
              <textarea className="em-textarea" placeholder="Enter project description"
                value={newProject.description ?? ""}
                onChange={(e) => setNewProject((p) => ({ ...p, description: e.target.value }))} />
            </div>

            <div className="em-field">
              <label className="em-label">Status</label>
              <select className="em-input" value={newProject.status ?? "Ongoing"}
                onChange={(e) => setNewProject((p) => ({ ...p, status: e.target.value }))}>
                {STATUS_OPTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>

            <button className="em-btn-save" onClick={handleAddProject} disabled={addLoading || !newProject.name}>
              {addLoading ? "Adding..." : "+ Add Project"}
            </button>
          </div>

        </div>

        <div className="em-footer">
          <button className="em-btn-cancel" onClick={onClose}>Close</button>
        </div>

      </div>
    </div>
  );
};
// ─────────────────────────────────────────────────────────────────────────────


const AdminProjects = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [activeTab, setActiveTab] = useState("All");

  const fetchPageData = async () => {
    setLoading(true);
    setFetchError(null);
    try {
      const { data } = await axios.get(`${BASE_URL}/api/project`);
      console.log("Raw API response:", data);
      const payload = data?.data ?? data;
      setPageData(payload);
      console.log("Resolved pageData:", payload);
    } catch (err) {
      console.error("Failed to fetch projects:", err);
      setFetchError(err.message);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 5000);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchPageData(); }, []);

  // ── Derive display projects ──
  const dbProjects = pageData?.projects ?? null;
  const displayProjects = dbProjects
    ? [...dbProjects].sort((a, b) => a.order - b.order)
    : staticProjects;

  const filteredProjects = activeTab === "All"
    ? displayProjects
    : displayProjects.filter((p) => p.status === activeTab);

  return (
    <div>
      <div className="container">
        <div className="content-wrapper">
          <div className="top-bar">
            <button
              className="edit-btn"
              title={loading ? "Loading..." : "Edit page"}
              onClick={() => setIsModalOpen(true)}
              disabled={loading}
            >
              <CiEdit size={18} />
            </button>
          </div>
          <div className="text-section">
            <p className="aboutusId wow animate__animated animate__fadeInUp">
              <span className="aboutusId-link">Home</span>
              <span className="separator">{">"}</span>
              <span className="aboutusId-link active">Projects</span>
            </p>
            <h1 className="main-heading wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
              {pageData?.title
                ? pageData.title
                : <>Our Work <br />Does the <span className="highlight">Talking.</span></>}
            </h1>
          </div>
        </div>

        <div className="image-section wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
          <img
            src={resolveSrc(pageData?.heroImage) || videoImg}
            alt="Construction workers operating heavy machinery"
            className="background-image"
          />
        </div>
      </div>

      <div className="projects-wrapper">
        <div className="projects-container">

          <div className="projects-header">
            <h1 className="wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">Projects</h1>
            <div className="projects-tabs">
              {["All", "Completed", "Ongoing"].map((tab) => (
                <span
                  key={tab}
                  className={`wow animate__animated animate__fadeInUp ${activeTab === tab ? "active" : ""}`}
                  data-wow-delay="0.3s"
                  onClick={() => setActiveTab(tab)}
                  style={{ cursor: "pointer" }}
                >
                  {tab === "All" ? "All Projects" : tab}
                </span>
              ))}
            </div>
          </div>

          <div className="projects-row header wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
            <div>Partners</div>
            <div>Project Title</div>
            <div className="status-header">Project Status</div>
          </div>

          {filteredProjects.map((project, index) => (
            <div className="projects-row" key={project._id || index}>
              <div className="partner wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
                <img
                  src={resolveSrc(project.photo, project.partnerLogo)}
                  alt="partner"
                />
              </div>
              <div className="title wow animate__animated animate__fadeInUp" data-wow-delay="0.5s">
                {project.name || project.title}
              </div>
              <div className="status wow animate__animated animate__fadeInUp" data-wow-delay="0.7s">
                {project.status}
              </div>
            </div>
          ))}

        </div>
      </div>

      <EditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        pageData={pageData}
        onRefresh={fetchPageData}
      />

      {showToast && (
        <div className="em-toast em-toast--error">
          <div className="em-toast-icon">✕</div>
          <div className="em-toast-body">
            <p className="em-toast-title">Failed to load page data</p>
            <p className="em-toast-message">{fetchError}</p>
          </div>
          <button className="em-toast-close" onClick={() => setShowToast(false)}>✕</button>
        </div>
      )}
    </div>
  );
};

export default AdminProjects